
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/[slug]",
      function () {
        return require("private-next-pages/embed/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/[slug]"])
      });
    }
  